import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button';
import { st, classes } from '../TagList.st.css.js';
const TagListAction = ({ className, size = 'tiny', skin = 'inverted', ...rest }) => (React.createElement(Button, { className: st(classes.item, className), size,
    skin,
    ...rest }));
TagListAction.displayName = 'TagListAction';
TagListAction.propTypes = {
    dataHook: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
};
export default TagListAction;
//# sourceMappingURL=TagListAction.js.map